export default {"src":"/_next/static/media/nusd.c7a22fdb.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};